/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Box, BoxProps, rem } from "@mantine/core"
import { BoxProps as MUIBoxProps } from "@mui/material"
import withMappedProps from "hoc-lib/propsMapping"
import { mapNumberPropResponsive } from "utils-lib/mappingUtils/index"

export const MantineBox = (props: BoxProps) => <Box {...props} />

export const muiToMantine = (
  props: MUIBoxProps,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
): BoxProps => {
  const { ...rest } = props

  const anyRest = rest as any

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return {
    ...anyRest,
    p: mapNumberPropResponsive(anyRest.p ?? anyRest.padding, (n) => rem(n * 8)),
    pt: mapNumberPropResponsive(anyRest.pt ?? anyRest.paddingTop, (n) =>
      rem(n * 8),
    ),
    pr: mapNumberPropResponsive(anyRest.pr ?? anyRest.paddingRight, (n) =>
      rem(n * 8),
    ),
    pb: mapNumberPropResponsive(anyRest.pb ?? anyRest.paddingBottom, (n) =>
      rem(n * 8),
    ),
    pl: mapNumberPropResponsive(anyRest.pl ?? anyRest.paddingLeft, (n) =>
      rem(n * 8),
    ),
    px: mapNumberPropResponsive(anyRest.px ?? anyRest.paddingX, (n) =>
      rem(n * 8),
    ),
    py: mapNumberPropResponsive(anyRest.py ?? anyRest.paddingY, (n) =>
      rem(n * 8),
    ),
    m: mapNumberPropResponsive(anyRest.m ?? anyRest.margin, (n) => rem(n * 8)),
    mt: mapNumberPropResponsive(anyRest.mt ?? anyRest.marginTop, (n) =>
      rem(n * 8),
    ),
    mr: mapNumberPropResponsive(anyRest.mr ?? anyRest.marginRight, (n) =>
      rem(n * 8),
    ),
    mb: mapNumberPropResponsive(anyRest.mb ?? anyRest.marginBottom, (n) =>
      rem(n * 8),
    ),
    ml: mapNumberPropResponsive(anyRest.ml ?? anyRest.marginLeft, (n) =>
      rem(n * 8),
    ),
    mx: mapNumberPropResponsive(anyRest.mx ?? anyRest.marginX, (n) =>
      rem(n * 8),
    ),
    my: mapNumberPropResponsive(anyRest.my ?? anyRest.marginY, (n) =>
      rem(n * 8),
    ),
    ta: anyRest.textAlign,
    lh: mapNumberPropResponsive(anyRest.lineHeight, (n) => rem(n * 4)),
    top: mapNumberPropResponsive(anyRest.top, (n) => rem(n * 8)),
    left: mapNumberPropResponsive(anyRest.left, (n) => rem(n * 8)),
    bottom: mapNumberPropResponsive(anyRest.bottom, (n) => rem(n * 8)),
    right: mapNumberPropResponsive(anyRest.right, (n) => rem(n * 8)),
    pos: anyRest.position,
    w: mapNumberPropResponsive(anyRest.w ?? anyRest.width, (n) => rem(n * 8)),
    h: mapNumberPropResponsive(anyRest.h ?? anyRest.height, (n) => rem(n * 8)),
    style: {
      borderRadius: mapNumberPropResponsive(anyRest.borderRadius, (n) =>
        rem(n * 4),
      ),
      justifyContent: anyRest.justifyContent,
      alignItems: anyRest.alignItems,
      alignContent: anyRest.alignContent,
      gap: anyRest.gap,
      whiteSpace: anyRest.whiteSpace,
      flexGrow: anyRest.flexGrow,
      flexShrink: anyRest.flexShrink,
      flexDirection: anyRest.flexDirection,
      flexWrap: anyRest.flexWrap,
      overflow: anyRest.overflow,
      ...anyRest.sx,
      ...anyRest.style,
    },
  }
}

export const MUIMappedBox = withMappedProps(MantineBox, muiToMantine)

export default MantineBox
